<template>
  <div>
    <v-card
      class="mx-4 my-4"
      outlined
      data-cypress-value="organisation-item"
    >
      <FavouritesButton
        :item="organisation"
      />

      <div
        class="organisation__link"
        ripple
      >
        <v-list-item three-line>
          <v-list-item-content @click="handleContentClick($event)">
            <router-link
              :to="{ name: 'organisation', params: { id: organisation.id }}"
              class="organisation__link"
              ripple
            >
              <v-list-item-title class="headline "><p>{{organisation.name}}</p></v-list-item-title>
            </router-link>
            <v-list-item v-if="organisation.telephone !== null && organisation.telephone !== ''">
              <v-list-item-icon>
                <v-icon color="primary">mdi-phone</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.catagories.phone}}</v-list-item-subtitle>
                <v-list-item-title><a :href="'tel:' + organisation.telephone">{{organisation.telephone}}</a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="organisation.email !== null && organisation.email !== ''">
              <v-list-item-icon>
                <v-icon color="primary">mdi-email</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.catagories.email}}</v-list-item-subtitle>
                <v-list-item-title class="email"><a :href="'mailto:' + organisation.email">{{organisation.email}}</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-content>
        </v-list-item>

        <v-card-actions>
          <v-btn class="v-btn--outlined white--text" :to="{ name: 'organisation', params: { id: organisation.id }}" text>{{hubbdata.catagories.info}}</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import FavouritesButton from '@/components/Favourites/FavouritesButton.vue';

export default {
  name: "OrganisationItem",
  props: {
    organisation: Object,
  },
  components: {
    FavouritesButton
  },
  computed: {
    hubbdata() {
      return hubbdata.getters.translations;
    },
  }
}
</script>

<style lang="scss">
.organisation__link {
  text-decoration: none !important;

  .v-card__actions {
    @media (max-width: 576px) {
      display: flex;
      justify-content: center;
    }

    @media (min-width: 577px) {
      margin-left: 8px;
    }
  }

  .email {
    width: 165px;
    white-space: normal;
  }

  .v-btn--outlined {
    background-color: #e9e8e6;
    outline: 1px solid $dark;
    color: $dark!important;
    font-weight: 18px;
    text-transform: capitalize;
    margin: 0 auto;
    font-weight: bold;

    @media screen and (min-width: 960px) {
      font-size: 16px;
    }
  }
}

.v-list-item__icon {
  margin: 16px 32px 0px 0px !important;
}

.headline p {
  white-space: pre-wrap;
  color: $primary !important;
}

.v-icon {
  color: white;
  font-size: 40px;
}
</style>